import * as React from "react";
import {Link} from "react-router-dom";
import { useLocation } from "react-router-dom";


import './Footer.css';

import { RiFacebookBoxFill, RiLinkedinFill } from 'react-icons/ri';

export function Footer (){

    const { pathname } = useLocation();
    const currentPath = pathname.split('/')

    function setYoffset(){
        window.scrollTo(0, 0);
    }
    

    if(!currentPath[2]){
        return (
            
            <footer>
                <section>
                    <ul className="liste-nav-footer">
                        <li><Link to="/NosRealisations" onClick={setYoffset()}>Nos réalisations</Link></li>
                        <li><Link to="/APropos" onClick={setYoffset()}>Qui sommes-nous?</Link></li>
                        <li><Link to="/TravaillerEnsemble" onClick={setYoffset()}>Travailler ensemble</Link></li>
                        <li><Link to="/FabriqueProjet" onClick={setYoffset()}>La Fabrique à Projets</Link></li>
                    </ul>
                    <article className="footer-logo">
                        <img src='./images/logo_carre_BI_nav.png' alt="Logo"></img>
                    </article>
                </section>

                <p className="email-footer">BUREAUIMAGINAIRE@GMAIL.COM</p>
                
                <article className="reseaux-sociaux-footer">
                    <ul>
                        <li><a href="https://www.facebook.com/bureauimaginaire" target="_blank"><RiFacebookBoxFill /></a></li>
                        <li><a href="https://www.linkedin.com/company/le-bureau-imaginaire/" target="_blank"><RiLinkedinFill /></a></li>
                    </ul>
                </article>
                <article className="mentions-legales">
                    <Link to="/MentionsLegales" onClick={setYoffset()}>Mentions légales</Link>
                    <Link to="/ProtectionDonnees" onClick={setYoffset()}>Protection des données</Link>
                </article>
                <article className="footer-bottom">
                    <p>Bureau-imaginaire © 2021-2022</p>
                </article>
            </footer>
        )
    }
}

